export const licitaciones2026 = [
  {
    titulo: "CONVOCATORIA 01-2026",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N1-2026",
      },
      {
        informacionTitulo: "EA-913005999-N2-2026",
      },
      {
        informacionTitulo: "EA-913005999-N3-2026",
      },
      {
        informacionTitulo: "EA-913005999-N4-2026",
      },
      {
        informacionTitulo: "EA-913005999-N5-2026",
      },
    ],
  },
];
